"use client";
import React, { useState, useEffect } from "react";
import {
  LuInfo,
  LuCircleX,
  LuCircleCheck,
  LuCircleAlert,
} from "react-icons/lu";

export type ToastMessage = {
  type?: "info" | "success" | "warning" | "error";
  message?: string;
};

const Toast = ({ toast }: { toast: ToastMessage | null }) => {
  const [currentToast, setCurrentToast] = useState<ToastMessage | null>(null);

  useEffect(() => {
    if (toast) {
      setCurrentToast(toast);
      const timeout = setTimeout(() => {
        setCurrentToast(null);
      }, 4000);
      return () => clearTimeout(timeout);
    }
  }, [toast]);

  if (!currentToast) return null;

  const getAlertClass = (type: ToastMessage["type"]) => {
    switch (type) {
      case "success":
        return "alert-success";
      case "error":
        return "alert-error";
      case "warning":
        return "alert-warning";
      case "info":
      default:
        return "alert-info";
    }
  };

  const getIcon = (type: ToastMessage["type"]) => {
    switch (type) {
      case "success":
        return <LuCircleCheck />;
      case "error":
        return <LuCircleX />;
      case "warning":
        return <LuCircleAlert />;
      case "info":
        return <LuInfo />;
      default:
        return <LuInfo />;
    }
  };

  return (
    <div className="toast toast-top mt-40 toast-right z-50 pointer-events-none">
      <div
        className={`alert ${getAlertClass(
          currentToast.type
        )} pointer-events-auto`}
      >
        <span className="flex items-center gap-2">
          {getIcon(currentToast.type)} {currentToast.message}
        </span>
      </div>
    </div>
  );
};

export default Toast;
